let csrfToken = null;

const getCsrfToken = async () => {
  if (csrfToken) return csrfToken;
  const response = await fetch("/api/auth/csrf-token", { credentials: "same-origin" });
  if (!response.ok) return null;
  const data = await response.json();
  csrfToken = data.csrf_token;
  return csrfToken;
};

export const apiFetch = async (url, options = {}) => {
  const method = (options.method || "GET").toUpperCase();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const token = await getCsrfToken();
    if (token) headers["X-CSRFToken"] = token;
  }

  const response = await fetch(url, {
    credentials: "same-origin",
    ...options,
    method,
    headers,
  });

  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await response.json() : null;

  if (!response.ok) {
    const error = new Error(data?.error || data?.errors?.[0] || "Request failed");
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};
